// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3gpZQ","savePackageButton":"ClientWallet_savePackageButton__3aUR0"};